module.exports = "//static.hsappstatic.net/setup-guide-components/static-1.45769/images/flywheel/service/pt.svg"